/** @flow **/

export const formFields = {
  login: {
    label: 'Enter Login',
    placeholder: 'Enter Login',
  },
  password: {
    label: 'Enter Password',
    placeholder: 'Enter Password',
  },
}